/**
 * Represents the type of a ChapterItem
 */
enum ChapterItemType {
	Slide = 'slide',
	Section = 'slideSection'
}

export default ChapterItemType;
